/* import __COLOCATED_TEMPLATE__ from './yield-location.hbs'; */
/* RESPONSIBLE TEAM: team-proactive-support */
import { type SafeString } from 'handlebars';
import Component from '@glimmer/component';
import type Coordinates from '../../../models/graph-editor/coordinates';
import type Edge from '../../../models/graph-editor/edge';
//@ts-ignore
import { sanitizeHtml } from '@intercom/pulse/lib/sanitize';

interface Args {
  edge: Edge;
  coordinates: Coordinates;
}

export default class GraphEditorEdgeYieldLocationComponent extends Component<Args> {
  get style(): SafeString {
    return sanitizeHtml(`
      --x: ${this.args.coordinates.x}px;
      --y: ${this.args.coordinates.y}px;
      pointer-events: ${this.args.edge.isDragging ? 'none' : 'all'};
    `);
  }
}
